import { render, staticRenderFns } from "./ViewCampaignEmailActivityReportPopUp.vue?vue&type=template&id=54685244&scoped=true&"
import script from "./ViewCampaignEmailActivityReportPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewCampaignEmailActivityReportPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewCampaignEmailActivityReportPopUp.vue?vue&type=style&index=0&id=54685244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54685244",
  null
  
)

export default component.exports